import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    multiModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";
import {RoutesOrganizedByTransportTypeType} from "@SearchResults/types/RoutesOrganizedByTransportType.type";
import {capitalize} from "@String/capitalize";

interface HowToContentProps {
    departure: string,
    destination: string,
    availableVehClasses: string,
    singleRoutes: RoutesOrganizedByTransportTypeType,
    fastestVehClass: TransportTypesType,
    slowestVehClass: TransportTypesType,
    priciestVehClass: TransportTypesType,
    cheapestVehClass: TransportTypesType,
}

function HowToContent(props: HowToContentProps) {
    const {
        departure,
        destination,
        singleRoutes,
        availableVehClasses,
        fastestVehClass,
        slowestVehClass,
        priciestVehClass,
        cheapestVehClass,
    } = props

    const fastestVehClassTranslation = capitalize(getTranslationFromTransportType(fastestVehClass))
    const slowestVehClassTranslation = capitalize(getTranslationFromTransportType(slowestVehClass))
    const priciestVehClassTranslation = getTranslationFromTransportType(priciestVehClass)
    const cheapestVehClassTranslation = getTranslationFromTransportType(cheapestVehClass)

    const {max: priciestPrice} = getMinMaxPriceForType(singleRoutes[priciestVehClass])
    const {min: cheapestPrice} = getMinMaxPriceForType(singleRoutes[cheapestVehClass])

    const title = useTranslation(
        `${multiModalTranslationKey}.how_to.title`,
        {departure, destination}
    )

    const description1 = useTranslation(
        `${multiModalTranslationKey}.how_to.desc1`,
        {
            departure,
            destination,
            availableVehClasses,
            fastestVehClass: fastestVehClassTranslation,
            slowestVehClass: slowestVehClassTranslation,
        }
    )

    const description2 = useTranslation(
        `${multiModalTranslationKey}.how_to.desc2`,
        {
            priciestPrice,
            priciestVehClass: priciestVehClassTranslation,
            cheapestPrice,
            cheapestVehClass: cheapestVehClassTranslation,
        }
    )

    return (
        <TitleAndContent
            title={title}
            content={[description1, description2]}
        />
    )
}

export default HowToContent